import { render, staticRenderFns } from "./drawSuccess.vue?vue&type=template&id=6b6bb8b6&scoped=true&"
import script from "./drawSuccess.vue?vue&type=script&lang=js&"
export * from "./drawSuccess.vue?vue&type=script&lang=js&"
import style0 from "./drawSuccess.vue?vue&type=style&index=0&id=6b6bb8b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6bb8b6",
  null
  
)

export default component.exports